<template>
    <mySubPage>
        <div slot="header">
            <myNav>修改用户信息</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="100px">
            <el-form-item :label="$t('logo_img')"  prop="img_link">
                <myCropImg :autoCropWidthHeight="[230,230]" crop_height="350px" crop_width="350px" :original_url='formData.img_lnk' @cropImgUpload="setImgLnk"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('wx_img_lnk')">
                <img class="width-100" :src="formData.wx_img_lnk" v-if="formData.wx_img_lnk != ''">
                <myUpImg @onChange="setWxImgLnk"></myUpImg>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item  :label="$t('user_code')" prop="user_code">
                        <el-input v-model="formData.user_code" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  :label="$t('user_cname')" prop="user_cname">
                        <el-input v-model="formData.user_cname"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('mobile')" prop="user_mobile">
                        <el-input v-model="formData.user_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item  :label="$t('birth')" prop="user_birth">
                        <el-date-picker type="date" v-model="formData.user_birth" :placeholder="$t('input')" :editable="false"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  :label="$t('sex')" prop="user_sex">
                        <el-radio-group v-model="formData.user_sex">
                            <el-radio v-for="item in user_sexs" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    import myUpImg from '../../../components/myUpImg'
    export default {
        components: {
            myCropImg,
            myUpImg
        },
        data:function(){
            return{
                relist:false,
                formData: {
                    u_id:'',
                    img_lnk:'',
                    wx_img_lnk:'',
                    user_code: '',
                    user_cname: '',
                    user_mobile: '',
                    user_sex: '',
                    user_birth: '',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    user_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_sex: [{required: true, message: this.$t('select'), trigger: 'change'}],
                },
                user_sexs:[],
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.u_id = this.$base.getRequest().id;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            setWxImgLnk: function (data){
                this.formData.wx_img_lnk = data.url;
            },
            getInfo: function(){
                var data = {
                    u_id: this.formData.u_id
                }
                this.$base.showLoading();
                this.$request.sendPost("user/before-upd", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData, data.info);
                        this.user_sexs = data.sexs;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.user_birth) {
                            this.formData.user_birth = this.$moment(this.formData.user_birth).format("YYYY-MM-DD");
                        }
                        this.$base.showLoading();
                            this.$request.sendPost("user/upd",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_upd.vue